export enum ECommType {
    FAX = 5,
    LETTER = 7,
    MEETING = 6,
    PHONE = 8,
    TASK = 3,
}
